import React from 'react'
import '../style/page_04.scss'
import { util } from '../config'
class Page04 extends React.Component {
  constructor(props) {
    super();
    this.state = {
      isRewardSend: false
    }
  }

  handleRewardSend = (e) => {
    const step = Number(e.currentTarget.dataset.step);
    if (!this.props.phone) {
      this.props.login();
      return;
    }
    if (step > this.props.info.count) {
      util.showToast({ msg: '未达成' });
      return;
    }
    if (this.props.info[`get${step}`]) {
      util.showToast({ msg: '已领取' });
      return;
    }
    this.props.toggleGiftPop(step);
  }

  render() {
    return (
      <div className="page page_04">
        <div className="title"></div>
        <div className="invite-gift-container">
          {[1, 2, 3].map(num => (
            <div key={num} className={`invite-gift invite-gift-${num}`}>
              <div data-step={num} className={`get-gift-btn ${this.props.info.count < num ? 'disabled' : ''} ${this.props.info[`get${num}`] ? 'got' : ''}`} onClick={this.handleRewardSend}></div>
            </div>
          ))}
        </div>
        <div className="invite-count">
          <div className="num-container">
            {this.props.info.count.toString().split('').map((num, index) => (
              <div key={index.toString()} className={`num num_${num}`}></div>
            ))}
          </div>
        </div>
        <div className="invite-btn" onClick={this.props.toggleInvitePop}></div>
        <div className="account-list-btn" onClick={this.props.toggleAccountPop}><i></i><span>登记角色</span></div>
        <div className="rule-btn" onClick={this.props.toggleRulePop}><i></i><span>规则说明</span></div>
      </div>
    )
  }
}

export default Page04;
